module.exports = __webpack_public_path__ + "static/media/depth.fe9e2766.vert";